import { render, staticRenderFns } from "./prize-statistics.vue?vue&type=template&id=66300cd0&scoped=true"
import script from "./prize-statistics.vue?vue&type=script&lang=js"
export * from "./prize-statistics.vue?vue&type=script&lang=js"
import style0 from "./prize-statistics.vue?vue&type=style&index=0&id=66300cd0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66300cd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66300cd0')) {
      api.createRecord('66300cd0', component.options)
    } else {
      api.reload('66300cd0', component.options)
    }
    module.hot.accept("./prize-statistics.vue?vue&type=template&id=66300cd0&scoped=true", function () {
      api.rerender('66300cd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/activities/components/prize-statistics.vue"
export default component.exports